import React from "react";
import { useBotWorkspace } from "../../../components/admin/BotWorkspace";
import { Navigate } from "react-router-dom";
import SchedulingTab from "../../../components/admin/scheduling/SchedulingTab";

export default function BotSchedulingPage({ section = "appointments" }) {
  const bot = useBotWorkspace();
  if (section === "schedulers") {
    return <Navigate replace to={`/agents/${encodeURIComponent(bot.id)}/agent-config?tab=schedulers`} />;
  }
  return <SchedulingTab botId={bot.id} activeSection={section} directLinks />;
}
